<template>
  <v-container>
    <v-card>
      <v-card-title>Notes</v-card-title>
      <v-card-text
        v-if="notes !== undefined && notes.length > 0"
      >
        <v-expansion-panels
          accordion
          multiple
        >
          <v-expansion-panel
            v-for="(note, n) in sorted_notes"
            v-show="note.deleted === 'n' || showAll"
            :key="`note-${n}`"
            :class="getNoteClass(note)"
            text
          >
            <v-expansion-panel-header
              disable-icon-rotate
            >
              <span class="text-h6">{{ note.title }}</span>
              <template v-slot:actions>
                <v-icon
                  :color="getNoteIconColour(note)"
                >
                  {{ getNoteIcon(note) }}
                </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col>
                  <template v-for="line in note.details.split('\n')">
                    {{ line }} <br />
                  </template>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  class="text-right"
                >
                  Last updated: {{ getUTCString(note.last_modified_date) }} by {{ note.last_modified_by_user.user_name }}
                </v-col>
              </v-row>
              <v-card-actions
                v-if="adminToggle"
              >
                <v-spacer />
                <notes-dialog
                  v-if="userHasPermission('edit_notes')"
                  :contract-id="contractId"
                  :note="note"
                  dialog-mode="Edit"
                  @editNote="editNote"
                />
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
      <v-card-text
        v-else
      >
        No notes found for this contract.
      </v-card-text>
      <v-card-actions
        v-if="adminToggle && userHasPermission('edit_notes')"
      >
        <v-spacer />
        <v-tooltip
          bottom
          color="primary"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="toggleShowAll"
            >
              <v-icon
                v-if="showAll"
              >
                mdi-eye-off
              </v-icon>
              <v-icon
                v-else
              >
                mdi-eye
              </v-icon>
            </v-btn>
          </template>
          <span>Show Hidden</span>
        </v-tooltip>
        <notes-dialog
          v-if="userHasPermission('edit_notes') && enabled"
          :contract-id="contractId"
          dialog-mode="New"
          @createNote="createNote"
        />
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { authHeader } from '@/util/helpers'
  import getEnv from '@/util/env'
  import { get, sync } from 'vuex-pathify'
  const host = getEnv('VUE_APP_API_HOST')
  export default {
    name: 'ContractNotes',
    props: {
      notes: Array,
      contractId: Number,
      enabled: Boolean,
    },
    data () {
      return {
        showAll: false,
      }
    },
    computed: {
      ...sync('app', [
        'adminToggle',
      ]),
      ...get('user', [
        'user'
      ]),
      sorted_notes () {
        return this.notes.sort((a, b) => {
          return (b.important === 'y') - (a.important === 'y') || (a.deleted === 'y') - (b.deleted === 'y')
        })
      },
    },
    methods: {
      userHasPermission: function (perm) {
        let perms = this.user.permissions.map(a => a.name)
        return perms.includes(perm)
      },
      getUTCString: function (datetime) {
        const d = new Date(datetime)
        return d.toUTCString()
      },
      getNoteIcon: function (note) {
        const important = note.important
        const deleted = note.deleted

        if (deleted === 'y') {
          return 'mdi-delete'
        }
        
        if (important === 'y') {
          return 'mdi-alert'
        } else {
          return 'mdi-information'
        }
      },
      getNoteIconColour: function (note) {
        const important = note.important
        const deleted = note.deleted

        if (deleted === 'y') {
          return 'grey'
        }
        
        if (important === 'y') {
          return 'error'
        } else {
          return 'info'
        }
      },
      getNoteClass: function (note) {
        const important = note.important
        const deleted = note.deleted

        if (deleted === 'y') {
          return 'v-alert--text grey--text'
        }
        
        if (important === 'y') {
          return 'v-alert--text error--text'
        } else {
          return 'v-alert--text info--text'
        }
      },
      createNote: function (noteData) {
        axios
          .post(
            `${host}/v2/notes/new`,
            noteData,
            {
              headers: authHeader(),
            },
          ) // eslint-disable-next-line
          .then(response => {
            this.$snackbar.showMessage({ content: 'Note created', color: 'success', timeout: 5000 })
            this.adminToggle = false
            setTimeout(() => this.$emit('updateContract'), 1000)
          })
          .catch(err => {
            console.log(err)
            this.$errordialog.showMessage({ content: 'There was an error, please try again.', color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
      editNote: function (noteData, noteId) {
        axios
          .put(
            `${host}/v2/notes/` + noteId,
            noteData,
            {
              headers: authHeader(),
            },
          ) // eslint-disable-next-line
          .then(response => {
            this.$snackbar.showMessage({ content: 'Note updated', color: 'success', timeout: 5000 })
            this.adminToggle = false
            setTimeout(() => this.$emit('updateContract'), 1000)
          })
          .catch(err => {
            console.log(err)
            this.$errordialog.showMessage({ content: 'There was an error, please try again.', color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
      toggleShowAll: function () {
        this.showAll = !this.showAll
      },
    }
  }
</script>
